const Data :any = {
    SUBMISSION_RECEIVED_BY_OFFER: {
        active: true,
        company: "AMARTA",
        message: "Form pembelian diterima oleh admin amarta",
        visible_targets: ["CUSTOMER", "DEALER"],
        broadcast: false,
        broadcast_method: ["WEB_NOTIFICATION"],
        external_info: {
            trigger: "LAMBDA-OFFER",
            external_data: []
        }
    },
    OFFER_CANCELED_BY_OFFER: {
        active: true,
        company: "AMARTA",
        message: "Form pembelian ditolak oleh admin amarta",
        visible_targets: ["CUSTOMER", "DEALER"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "LAMBDA-OFFER",
            external_data: []
        }
    },
    PAYMENT_PROCESS: {
        active: true,
        company: "AMARTA",
        message: "Pembayaran terkonfirmasi oleh system",
        visible_targets: ["CUSTOMER", "DEALER"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "LAMBDA-FIN-PAYMENT",
            external_data: ["payment_code", "payment_method", "payment_channel", "payment_amount"]
        }
    },
    OFFER_CLOSED_TO_ORDER: {
        active: true,
        company: "AMARTA",
        message: "Admin dealer berhasil mengalokasikan unit",
        visible_targets: ["CUSTOMER", "DEALER"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "LAMBDA-OFFER",
            external_data: ["order_code"]
        }
    },
    DELIVERY_ORDER: {
        active: true,
        company: "AMARTA",
        message: "Pesanan telah dijadwalkan untuk dikirim",
        visible_targets: ["CUSTOMER", "DEALER"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "LAMBDA-OTODIS",
            external_data: ["order_code", "delivery_code", "driver_name", "driver_license_plate"]
        }
    },
    CANCEL_ORDER: {
        active: true,
        company: "AMARTA",
        message: "Order telah dibatalkan oleh admin",
        visible_targets: ["CUSTOMER", "DEALER"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "LAMBDA-OTODIS",
            external_data: ["order_code"]
        }
    },
    CANCEL_DELIVERY: {
        active: true,
        company: "AMARTA",
        message: "Pengiriman telah dibatalkan oleh admin",
        visible_targets: ["CUSTOMER", "DEALER"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "LAMBDA-OTODIS",
            external_data: ["order_code", "delivery_code", "driver_name", "driver_license_plate"]
        }
    },
    SENT_ORDER: {
        active: true,
        company: "AMARTA",
        message: "Pesanan dikirim oleh driver",
        visible_targets: ["CUSTOMER", "DEALER"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "VPS-AMREN",
            external_data: ["order_code", "delivery_code", "driver_name", "driver_license_plate"]
        }
    },
    UNIT_ACCEPTED: {
        active: true,
        company: "AMARTA",
        message: "Pesanan diterima konsumen",
        visible_targets: ["CUSTOMER", "DEALER"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "VPS-AMREN",
            external_data: ["order_code", "delivery_code", "driver_name", "driver_license_plate", "recipient_name"]
        }
    },

    SUBMISSION_RECEIVED_BY_B2B: {
        active: true,
        company: "AMARTA",
        message: "Form pembelian diterima oleh admin b2b",
        visible_targets: ["CUSTOMER", "B2B"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "CLOUDFUNC-B2B",
            external_data: []
        }
    },
    OFFER_ASSIGNED_BY_B2B: {
        active: true,
        company: "AMARTA",
        message: "Aju kredit ditugaskan",
        visible_targets: ["B2B", "FINCO"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "CLOUDFUNC-B2B",
            external_data: []
        }
    },
    OFFER_ACCEPTED_BY_FINCO: {
        active: true,
        company: "AMARTA",
        message: "Aju kredit diterima oleh admin finco",
        visible_targets: ["B2B", "FINCO"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "CLOUDFUNC-B2B",
            external_data: []
        }
    },
    OFFER_REJECTED_BY_FINCO: {
        active: true,
        company: "AMARTA",
        message: "Aju kredit ditolak oleh admin finco",
        visible_targets: ["B2B", "FINCO"],
        broadcast: true,
        broadcast_method: [],
        external_info: {
            trigger: "CLOUDFUNC-B2B",
            external_data: []
        }
    },
    OFFER_SURVEYED_BY_FINCO: {
        active: true,
        company: "AMARTA",
        message: "Aju kredit selesai disurvey oleh admin finco",
        visible_targets: ["CUSTOMER", "B2B", "FINCO"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "CLOUDFUNC-B2B",
            external_data: []
        }
    },
    SURVEY_ACCEPTED_BY_B2B: {
        active: true,
        company: "AMARTA",
        message: "aju kredit disetujui untuk diteruskan ke dealer",
        visible_targets: ["CUSTOMER", "B2B", "FINCO"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "CLOUDFUNC-B2B",
            external_data: []
        }
    },
    OFFER_WITHDRAW_BY_B2B: {
        active: true,
        company: "AMARTA",
        message: "Aju kredit ditarik kembali oleh admin B2B",
        visible_targets: ["B2B", "FINCO"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "CLOUDFUNC-B2B",
            external_data: []
        }
    },
    DOC_VEHICLE_REGISTRATION_RECEIVED: {
        active: true,
        company: "AMARTA",
        message: "dokumen surat stnk sudah diterima di dealer",
        visible_targets: ["DEALER"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "LAMBDA-OTODIS",
            external_data: ["order_code", "document_code", "license_plate"]
        }
    },
    DOC_VEHICLE_OWNERSHIP_RECEIVED: {
        active: true,
        company: "AMARTA",
        message: "dokumen surat bpkb sudah diterima di dealer",
        visible_targets: ["DEALER"],
        broadcast: false,
        broadcast_method: [],
        external_info: {
            trigger: "LAMBDA-OTODIS",
            external_data: ["order_code", "document_code", "license_plate"]
        }
    },
};

export default Data;
